import { Box, Typography } from "@mui/material";
import {
	EnhancedDropDownRHFWithLabel,
	FieldLayout,
	ITest,
	LabelPosition,
	RHookFormDatePicker,
} from "@websential/cosmic-v20";
import { FC, useEffect, useState } from "react";

interface ILiabilitiesInfoFieldsPanel extends ITest {
	accountSettingsDDL: any;
	addedEmployeesprovince: any;
}

export const LiabilitiesInfoFieldsPanel: FC<
	ILiabilitiesInfoFieldsPanel
> = ({ accountSettingsDDL, addedEmployeesprovince }) => {

	return (
		<>
			<EnhancedDropDownRHFWithLabel
				label="Payroll Liability (Net Pay)"
				selectName="payrollLiabilityNetPay"
				testId="payroll-liability-net-pay"
				labelPosition={LabelPosition.Top}
				items={accountSettingsDDL ?? []}
				labelColumns={4}
				fieldColumns={8}
				showEmpty
			/>

			<EnhancedDropDownRHFWithLabel
				label="Federal Tax"
				selectName="federalTax"
				testId="federal-tax"
				labelPosition={LabelPosition.Top}
				items={accountSettingsDDL ?? []}
				labelColumns={4}
				fieldColumns={8}
				showEmpty
			/>

			<EnhancedDropDownRHFWithLabel
				label="Provincial Tax"
				selectName="provincialTax"
				testId="provincial-tax"
				labelPosition={LabelPosition.Top}
				items={accountSettingsDDL ?? []}
				labelColumns={4}
				fieldColumns={8}
				showEmpty
			/>

			<EnhancedDropDownRHFWithLabel
				label="CPP - Employee"
				selectName="cppEmployee"
				testId="cpp-employee"
				labelPosition={LabelPosition.Top}
				items={accountSettingsDDL ?? []}
				labelColumns={4}
				fieldColumns={8}
				showEmpty
			/>

			<EnhancedDropDownRHFWithLabel
				label="EI - Employee"
				selectName="eiEmployee"
				testId="ei-employee"
				labelPosition={LabelPosition.Top}
				items={accountSettingsDDL ?? []}
				labelColumns={4}
				fieldColumns={8}
				showEmpty
			/>

			{addedEmployeesprovince?.provincesForTDForm?.QC &&
				<><EnhancedDropDownRHFWithLabel
					label="QPP - Employee"
					selectName="qppEmployee"
					testId="qpp-employee"
					labelPosition={LabelPosition.Top}
					items={accountSettingsDDL ?? []}
					labelColumns={4}
					fieldColumns={8}
					showEmpty
				/>

					<EnhancedDropDownRHFWithLabel
						label="QPIP - Employee"
						selectName="qpipEmployee"
						testId="qpip-employee"
						labelPosition={LabelPosition.Top}
						items={accountSettingsDDL ?? []}
						labelColumns={4}
						fieldColumns={8}
						showEmpty
					/></>}

			<EnhancedDropDownRHFWithLabel
				label="CPP - Company"
				selectName="cppCompany"
				testId="cpp-company"
				labelPosition={LabelPosition.Top}
				items={accountSettingsDDL ?? []}
				labelColumns={4}
				fieldColumns={8}
				showEmpty
			/>

			<EnhancedDropDownRHFWithLabel
				label="EI - Company"
				selectName="eiCompany"
				testId="ei-company"
				labelPosition={LabelPosition.Top}
				items={accountSettingsDDL ?? []}
				labelColumns={4}
				fieldColumns={8}
				showEmpty
			/>

			{addedEmployeesprovince?.provincesForTDForm?.QC &&
				<><EnhancedDropDownRHFWithLabel
					label="QPP - Company"
					selectName="qppCompany"
					testId="qpp-company"
					labelPosition={LabelPosition.Top}
					items={accountSettingsDDL ?? []}
					labelColumns={4}
					fieldColumns={8}
					showEmpty
				/>

					<EnhancedDropDownRHFWithLabel
						label="QPIP - Company"
						selectName="qpipCompany"
						testId="qpip-company"
						labelPosition={LabelPosition.Top}
						items={accountSettingsDDL ?? []}
						labelColumns={4}
						fieldColumns={8}
						showEmpty
					/>

					<EnhancedDropDownRHFWithLabel
						label="QHSF - Company"
						selectName="qhsfCompany"
						testId="qhsf-company"
						labelPosition={LabelPosition.Top}
						items={accountSettingsDDL ?? []}
						labelColumns={4}
						fieldColumns={8}
						showEmpty
					/>

					<EnhancedDropDownRHFWithLabel
						label="CSST - Company"
						selectName="csstCompany"
						testId="csst-company"
						labelPosition={LabelPosition.Top}
						items={accountSettingsDDL ?? []}
						labelColumns={4}
						fieldColumns={8}
						showEmpty
					/></>}

			<EnhancedDropDownRHFWithLabel
				label="Additional Tax (TD1)"
				selectName="additionalTaxTd1"
				testId="additional-tax-td1"
				labelPosition={LabelPosition.Top}
				items={accountSettingsDDL ?? []}
				labelColumns={4}
				fieldColumns={8}
				showEmpty
			/>

			<EnhancedDropDownRHFWithLabel
				label="Deductions at Source"
				selectName="deuctionsAtSource"
				testId="deductions-at-source"
				labelPosition={LabelPosition.Top}
				items={accountSettingsDDL ?? []}
				labelColumns={4}
				fieldColumns={8}
				showEmpty
			/>

			<EnhancedDropDownRHFWithLabel
				label="Advance Deduction"
				selectName="advanceDeductions"
				testId="advance-deduction"
				labelPosition={LabelPosition.Top}
				items={accountSettingsDDL ?? []}
				labelColumns={4}
				fieldColumns={8}
				showEmpty
			/>

			<EnhancedDropDownRHFWithLabel
				label="WSIB Payable"
				selectName="wsibPayable"
				testId="wsib-payable"
				labelPosition={LabelPosition.Top}
				items={accountSettingsDDL ?? []}
				labelColumns={4}
				fieldColumns={8}
				showEmpty
			/>
		</>
	);
};
